export const FIND_ASSIGNABLE_PRODUCTS = `
  query FindAssignableProducts($filter: FindAssignableProductsFilter!, $page: PageRequest) {
    addon {
      findAssignableProducts(filter: $filter, page: $page) {
        count
        limit
        offset
        items {
          id
          name
          description
          details
        }
      }
    }
  }
`;
